import Tweet from '@/common/Tweet';
import CRetweetist from '@/static/assets/pet/tweets/CRetweetist.jpg';
import MickaelCostache from '@/static/assets/pet/tweets/MickaelCostache.jpg';
import ann from '@/static/assets/pet/tweets/ann.jpg';
import goldie from '@/static/assets/pet/tweets/goldie.jpg';
import nonna from '@/static/assets/pet/tweets/nonna.jpg';
import vassilis from '@/static/assets/pet/tweets/vassilis.jpg';
import { Flex, font } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import styled, { keyframes } from 'styled-components';

export interface TweetProps {
  name: string;
  img: string;
  handle: string;
  text: string;
}

export const DEFAULT_TWEETS: TweetProps[] = [
  {
    name: 'Chief retweetist',
    img: CRetweetist.src,
    handle: 'CRetweetist',
    text: 'Where do I sign <span class="primary">@Lemonade_Inc</span>?',
  },
  {
    name: 'Mickael Costache',
    img: MickaelCostache.src,
    handle: 'MickaelCostache',
    text: 'What <span class="primary">@Lemonade_Inc</span> has built is pretty unbelievable. Such an amazing user experience in this "non sexy" insurance industry. Congrats to the team!',
  },
  {
    name: 'Nonna Polonskaya',
    img: nonna.src,
    handle: 'nzlata',
    text: 'Thanks to <span class="primary">@Lemonade_Inc</span> for a much needed dose of inspiration for the insurance industry! ✊ <span class="primary">#innovation #insurtech</span>',
  },
  {
    name: 'Goldie Chan',
    img: goldie.src,
    handle: 'GoldieChan',
    text: 'Wow, just got insurance with <span class="primary">@Lemonade_Inc</span> and it was super easy - took 10-15m. Strong customer service and cute UI 💚👍',
  },
  {
    name: 'Vassilis Tziokas',
    img: vassilis.src,
    handle: 'TziokasV',
    text: 'Traditional business model re-invented by digital technologies. Focus on a great <span class="primary">#CustomerExperience</span>. Behavioral economics engineering. Promoting social impact. Kudos to <span class="primary">@Lemonade_Inc</span> for showing how true <span class="primary">#digitaltranformation</span> is done!',
  },
  {
    name: 'Ann Bordetsky',
    img: ann.src,
    handle: 'annbordetsky',
    text: 'This company made INSURANCE of all things fun and exciting. And then backed it up with a fantastic biz. I’m in awe of <span class="primary">@Lemonade_Inc</span>. 👏',
  },
];

const marqueeAnimation = keyframes`
    0% {
        transform: translateX(-23%);
    }

    100% {
        transform: translateX(-123%);
    }
`;

const TWEET_WIDTH = 408;
const DURATION_PER_TWEET = 4100;

export interface Props {
  tweets?: TweetProps[];
  durationPerTweet?: number;
}

const TweetCard = styled(Tweet)`
  height: 240px;
  width: 338px;
  box-shadow:
    0 2px 12px 0 rgba(0, 0, 0, 0.06),
    0 47px 46px -27px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  padding: 20px;
  box-sizing: content-box;

  p {
    ${font('main', { fontSize: '1.6rem', lineHeight: '2.2rem' })}
  }
`;

const TweetsMarquee = styled(Flex).attrs(
  ({ tweets = DEFAULT_TWEETS, durationPerTweet = DURATION_PER_TWEET }: Props) => ({
    width: tweets.length * TWEET_WIDTH,
    style: { animationDuration: `${tweets.length * durationPerTweet}ms` },
    children: tweets.concat(tweets).map((tweet, idx) => {
      // concat extra tweets to make animation continuous
      return (
        <div key={`${tweet.handle}-${idx}`}>
          <TweetCard tweet={tweet} />
        </div>
      );
    }),
  }),
)`
  align-self: start;
  height: 292px;
  position: relative;
  animation: ${marqueeAnimation} linear infinite;

  ${MEDIA_QUERIES.desktop`
        &:hover {
            animation-play-state: paused;
        }
    `}

  ${MEDIA_QUERIES.mobile`
        top: 15px;
        animation-duration: 33000ms;
    `}
`;

export default TweetsMarquee;
